// MACHINERY V2 (Stroje) — profile tab bodies: PLACEHOLDERS ONLY (M2.4).
//
// >>> EVERY BODY IN THIS FILE IS A SKELETON TO BE REPLACED. <<<
//   live            -> REPLACE AT M2.10  (MashLiveLedger — the signal ledger;
//                      backend-gated, ticket §6/§7. The dark "feed controls"
//                      simulator rig in artboard 0601 is prototype-only and is
//                      NOT built, ever — ticket §4.2.)
//   serviceReports  -> REPLACE AT M2.5   (ServiceReportsTabV2)
//   documents       -> REPLACE AT M2.5   (DocumentsTabV2)
//   specifications  -> REPLACE AT M2.5   (SpecificationsTabV2)
//   parts           -> REPLACE AT M2.5   (PartsTabV2)
//
// M2.4 ships the SHELL: hero, tab set, tab gating, default tab, actions. Tab
// CONTENT is explicitly out of scope for this sub-phase, so each body renders
// one honest "being rebuilt" card rather than a half-wired list that would ship
// to `.cc` on the next deploy looking like a broken feature.
//
// The placeholder deliberately does NOT deep-link to the live tab: the live
// profile stays byte-untouched until cutover (M2.12) and a link out of the v2
// surface into v1 mid-page would strand the user on the old chrome.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import {
  MachineryV2ProfileTab,
  PROFILE_TAB_LABEL_KEYS,
} from "./profileTabContract";

export interface ProfileTabBodyProps {
  tab: MachineryV2ProfileTab;
}

const ProfileTabBody: React.FC<ProfileTabBodyProps> = ({ tab }) => {
  const { translate } = useTranslation("myMachinery");

  return (
    <div
      style={{
        background: "var(--bg-soft)",
        border: "1px dashed var(--border)",
        borderRadius: 12,
        padding: "28px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        textAlign: "center",
        minHeight: 220,
        minWidth: 0,
      }}
    >
      <div className="eyebrow">{translate(PROFILE_TAB_LABEL_KEYS[tab])}</div>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink-2)" }}>
        {translate("myMachinery:v2.profile.comingSoon")}
      </div>
      <div style={{ fontSize: 12.5, color: "var(--muted)", maxWidth: 420 }}>
        {translate("myMachinery:v2.profile.comingSoonHint")}
      </div>
    </div>
  );
};

export default ProfileTabBody;
